/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The diluent volume is the final volume minus the stock volume (V2 − V1). For the 10 mL of stock into 100 mL example, you add 90 mL of solvent.`)
};

const es_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El volumen de diluyente es el volumen final menos el volumen de stock (V2 − V1). Para el ejemplo de 10 mL de stock en 100 mL, añades 90 mL de disolvente.`)
};

const de_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Volumen des Verdünnungsmittels ist das Endvolumen abzüglich des Stammvolumens (V2 − V1). Beim Beispiel mit 10 mL Stammlösung in 100 mL fügen Sie 90 mL Lösungsmittel hinzu.`)
};

const nl_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het volume verdunningsmiddel is het eindvolume min het stockvolume (V2 − V1). Voor het voorbeeld van 10 mL stock in 100 mL voeg je dus 90 mL oplosmiddel toe.`)
};

const fr_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le volume de diluant est le volume final moins le volume de solution mère (V2 − V1). Pour l'exemple des 10 mL de solution mère dans 100 mL, vous ajoutez 90 mL de solvant.`)
};

const it_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il volume di diluente è il volume finale meno il volume di madre (V2 − V1). Per l'esempio di 10 mL di madre in 100 mL, aggiungi 90 mL di solvente.`)
};

const pt_br2_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de diluente é o volume final menos o volume do estoque (V2 − V1). No exemplo de 10 mL de estoque em 100 mL, você adiciona 90 mL de solvente.`)
};

const pt_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O volume de diluente é o volume final menos o volume da solução-mãe (V2 − V1). No exemplo dos 10 mL de solução-mãe para 100 mL, adiciona 90 mL de solvente.`)
};

const ja_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希釈剤の体積は最終体積からストック体積を引いたもの (V2 − V1) です。ストック10 mLを100 mLにする例では、溶媒を90 mL加えます。`)
};

const zh_soldil_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀释剂体积等于终体积减去母液体积（V2 − V1）。对于将 10 mL 母液配成 100 mL 的例子，你需要加入 90 mL 溶剂。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_a3", locale)
	if (locale === "en") return en_soldil_faq_a3(inputs)
	if (locale === "es") return es_soldil_faq_a3(inputs)
	if (locale === "de") return de_soldil_faq_a3(inputs)
	if (locale === "nl") return nl_soldil_faq_a3(inputs)
	if (locale === "fr") return fr_soldil_faq_a3(inputs)
	if (locale === "it") return it_soldil_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_a3(inputs)
	if (locale === "pt") return pt_soldil_faq_a3(inputs)
	if (locale === "ja") return ja_soldil_faq_a3(inputs)
	return zh_soldil_faq_a3(inputs)
};